import { LIMITS } from 'shared'
import { create, enforce, omitWhen, test } from 'vest'
import { messages } from './messages'

export function validateFunction(name: string, accountIsOnAllowList: boolean) {
  const { validation } = messages

  return create((value: string | undefined, { intl: { $t } }) => {
    test(name, $t(validation.required), () => {
      enforce(value).isNotEmpty()
    })

    omitWhen(accountIsOnAllowList, () => {
      // Promotion name max length validation is omitted for a few accounts due to incident 1988.
      // This validation will be re-enabled for all accounts once the breaking change document is released.
      test(
        name,
        $t(validation.maxLength, {
          length: LIMITS.MAX_PROMOTION_NAME_LENGTH,
        }),
        () => {
          enforce(value).shorterThanOrEquals(LIMITS.MAX_PROMOTION_NAME_LENGTH)
        }
      )
    })
  })
}
